import { format } from "date-fns";
import { motion } from "motion/react";
import { useEffect, useMemo } from "react";
import { SubmitPreviewImage } from "../components/editor/SubmitPreviewImage";
import { useBackendContext } from "../services/backend/backendContextProvider";
import style from './Stage.module.css';
import { useTranslation } from "react-i18next";
import { T } from "../i18n/LocaleType";

export const Stage: React.FC = () => {

    const { session } = useBackendContext();

    const { t } = useTranslation();

    const submitted = useMemo( () => {

        if ( session?.submitted ) {
            return format( new Date( session.submitted ), "d. M. yyyy H:mm:ss" );
        }

        return undefined;

    }, [session] );

    useEffect( ()=> {

        let refreshTimeout: ReturnType<typeof setTimeout> | null = null;

        const onVisibilityChange = () => {
            if ( document.visibilityState === "visible" ) {
                // Krátký delay aby se zabránilo refreshi při rychlém přepnutí
                refreshTimeout = setTimeout( () => {
                    window.location.reload();
                }, 2000 );
            } else {
                // Stránka jde do pozadí — zruš případný pending refresh
                if ( refreshTimeout ) {
                    clearTimeout( refreshTimeout );
                    refreshTimeout = null;
                }
            }
        };

        document.addEventListener( "visibilitychange", onVisibilityChange );

        return () => {
            document.removeEventListener( "visibilitychange", onVisibilityChange );
            if ( refreshTimeout ) {
                clearTimeout( refreshTimeout );
            }
        };

    }, [session]);

    return <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
        className={style.loading}
        style={{ position: 'absolute', inset: 0 }}
    >
        <div className={style.container}>
            <p>{t(T.your_drawing_was_submitted)}</p>

            <p>{t(T.wait_to_show_on_facade)}</p>

            <SubmitPreviewImage />

            <p>{submitted}</p>

            
        </div>
    </motion.div>
}